// extracted by mini-css-extract-plugin
export default {"left":"gU0RJXICKhu9V6VewIaG","icon":"WTEW9luokN_DSHKTsR8A"};